/**
 * 接口地址
 * @type {string}
 */


let api_base = `https://ypsm.wolkm.cn/admproj/`
// let api_base = `https://myzb.wolkm.cn/admproj/`

if (process.env.NODE_ENV == 'development') {
    api_base = `/admproj/`
}

export const API_BASE_URL = api_base;
